import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconHistory$1 = /*@__PURE__*/ proxyCustomElement(class WppIconHistory extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-history", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M9.37217 2.02507C13.7768 1.67841 17.6285 4.96807 17.9752 9.37273C18.3218 13.7774 15.0322 17.6291 10.6275 17.9757C6.22286 18.3224 2.37116 15.0327 2.02451 10.6281C2.0022 10.3446 1.99593 10.04 2.00495 9.73892C2.01736 9.3249 2.36306 8.99932 2.77709 9.01173C3.19111 9.02414 3.51669 9.36984 3.50428 9.78387C3.49683 10.0325 3.50199 10.283 3.51988 10.5104C3.80154 14.0892 6.93105 16.762 10.5098 16.4804C14.0886 16.1987 16.7615 13.0692 16.4798 9.49042C16.1982 5.91164 13.0686 3.23879 9.48986 3.52044C7.75359 3.65709 6.18414 4.4709 5.07752 5.75512L4.87398 6.003L6.75098 6.00387L6.85275 6.01072C7.21882 6.06038 7.50098 6.37417 7.50098 6.75387C7.50098 7.13356 7.21882 7.44736 6.85275 7.49702L6.75098 7.50387H3.25284L3.15107 7.49702C2.81827 7.45187 2.55483 7.18844 2.50968 6.85564L2.50284 6.75387V2.75387L2.50968 2.6521C2.55483 2.3193 2.81827 2.05586 3.15107 2.01072L3.25284 2.00387L3.35461 2.01072C3.6874 2.05586 3.95084 2.3193 3.99599 2.6521L4.00284 2.75387L4.00163 4.70662C5.35953 3.16672 7.26754 2.1907 9.37217 2.02507ZM9.74985 6.00387L9.85162 6.01072C10.1844 6.05586 10.4479 6.3193 10.493 6.6521L10.4998 6.75387V9.9994L12.2498 10.0004L12.3516 10.0073C12.7177 10.0569 12.9998 10.3707 12.9998 10.7504C12.9998 11.1301 12.7177 11.4439 12.3516 11.4936L12.2498 11.5004H9.74985L9.64808 11.4936C9.31528 11.4484 9.05184 11.185 9.00669 10.8522L8.99985 10.7504V6.75387L9.00669 6.6521C9.05184 6.3193 9.31528 6.05586 9.64808 6.01072L9.74985 6.00387Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-history-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-history", "wpp-icon-history-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-history-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-history-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconHistory$1);
      }
      break;
  } });
}

const WppIconHistory = WppIconHistory$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconHistory, defineCustomElement };
